export default __webpack_public_path__ + "static/media/rating-3.ab58a190.webp";